import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

/**
 * Password field with show/hide toggle. Pass inputClassName to match rdp-input, modal, etc.
 */
export default function PasswordInput({
  label,
  labelClassName,
  value,
  onChange,
  name,
  id,
  placeholder,
  autoComplete,
  required,
  disabled,
  inputClassName,
  wrapperClassName = '',
  toggleClassName = 'text-white/45 hover:text-white/90'
}) {
  const [show, setShow] = useState(false);

  return (
    <div className={wrapperClassName}>
      {label ? (
        <label htmlFor={id} className={labelClassName || 'mb-2 block text-[#FFFFFF]'}>
          {label}
        </label>
      ) : null}
      <div className="relative">
        <input
          id={id}
          name={name}
          type={show ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          disabled={disabled}
          className={inputClassName}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShow((s) => !s)}
          className={`absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 transition ${toggleClassName}`}
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? <FiEyeOff size={18} /> : <FiEye size={18} />}
        </button>
      </div>
    </div>
  );
}
